import { render, staticRenderFns } from "./shopHome.vue?vue&type=template&id=0b02d1f4&"
import script from "./shopHome.vue?vue&type=script&lang=js&"
export * from "./shopHome.vue?vue&type=script&lang=js&"
import style0 from "./shopHome.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports